import React from "react";
import { 
    BranchSalesPanel,
    CampaignConversionPanel,
    DemographicPanel,
    FilterPanelV3,
    MiscellaneousPanel,
    ProductBrandPanel,
} from "modules/reporting/components/panel";
import { Content } from "modules/reporting/components/layout";

export default function BrandPage({
    filter,
    tagUrl,
    currentFilter,
    pageMode,
    translate
}) {
    const pageType = "product-brand";
    return (
        <>
            <FilterPanelV3
                filter={filter}
                currentFilter={currentFilter}
                pageMode={pageMode}
                translate={translate}
            />

            <Content>
                {/* trending card row --- START */}
                <ProductBrandPanel 
                    currentFilter={currentFilter} 
                    urlTotalScan={tagUrl + "get-total-scan-qr"} 
                    urlTotalSuspended={tagUrl + "get-total-suspended-qr"} 
                    urlTotalDistributionPerformance={tagUrl + "get-distribution-performance"}
                    urlBrand={tagUrl + "get-brand-scan"}
                    urlScanAgainstSuspended = {tagUrl + "scan-vs-suspended"}

                    pageType={pageType}
                    translate={translate}
                />
                {/* trending card row --- END */}

                {/* campaigns conversion --- START */}
                <CampaignConversionPanel 
                    currentFilter={currentFilter} 
                    url={tagUrl + "get-campaigns-conversion"} 
                    // url={"http://localhost:9080/campaignConversionDrilldown"}

                    pageType={pageType}
                    translate={translate}
                />
                {/* campaigns conversion --- END */}

                {/* demographic card row --- START*/}
                <DemographicPanel 
                    currentFilter={currentFilter}
                    urlAge={tagUrl + "get-total-age"} 
                    urlGender={tagUrl + "get-total-gender" } 
                    urlGenderAge={tagUrl + "get-total-gender-age"}
                    urlCountry={tagUrl + "get-country"}
                    urlCity={tagUrl + "get-city"}

                    pageType={pageType}
                    translate={translate}
                />
                {/* demographic card row --- END */}

                {/* branch sales detail row --- START*/}
                {
                    !currentFilter.branchUuid ? 
                    (
                        <BranchSalesPanel 
                            url={tagUrl + "get-branch"}
                            currentFilter={currentFilter}
        
                            pageType={pageType}
                            translate={translate}
                        /> 
                    ): null
                }
                {/* branch sales detail row --- END*/}  

                {/* miscellaneous card row --- START */}
                <MiscellaneousPanel 
                    currentFilter={currentFilter}
                    urlPlatform={tagUrl + "get-total-platform"}
                    urlDevice={tagUrl + "get-total-device"}
                    urlBrowser={tagUrl + "get-total-browser"}
                    urlLanguage={tagUrl + "get-total-language"}
                    translate={translate}
                />
                {/* miscellaneous card row --- END */}
            </Content>
        </>
    )
}